
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    containerTable: {
        display: 'table',
        width: '100%'
    },
    containerTableCell: {
        display: 'table-cell'
    },
    containerTableCell_fullWidth: {
        width: '100%'
    },
    containerTableCell_alignMiddle: {
        verticalAlign: 'middle'
    },
    link: {
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        fontSize: '19px',
        lineHeight: '24px',
        letterSpacing: undefined,
        paddingTop: '12px',
        paddingBottom: '12px',
        color: '#484848',
        fontWeight: 300,
        display: 'block',
        textDecoration: 'none',
        position: 'relative'
    },
    newText: {
        fontStyle: 'italic',
        color: '#33d1ff'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/Header/FlyoutMenu/FlyoutNav/FlyoutNavLink/styles.js